module.exports = __webpack_public_path__ + "static/media/crc.11e4664b.png";